import React from 'react';
import { motion } from 'framer-motion';
import { Pencil, Palette, BookOpen, CalendarRange, FlaskConical, ClipboardCheck } from 'lucide-react';
const tomos = [{
  n: 'TOMO 1',
  Icon: Pencil,
  title: 'Dibujo y Expresión Visual',
  desc: 'Técnicas de dibujo, retrato, perspectiva e ilustración secuencial para todos los años de secundaria.'
}, {
  n: 'TOMO 2',
  Icon: Palette,
  title: 'Pintura y Color',
  desc: 'Teoría del color, técnicas pictóricas, acuarela, acrílico y propuestas de pintura expresiva.'
}, {
  n: 'TOMO 3',
  Icon: BookOpen,
  title: 'Historia del Arte',
  desc: 'Movimientos clave, arte argentino, arte contemporáneo. Material teórico breve y aplicable.'
}, {
  n: 'TOMO 4',
  Icon: CalendarRange,
  title: 'Proyectos Anuales',
  desc: 'Propuestas integradoras por trimestre, con muestras finales y trabajo colaborativo.'
}, {
  n: 'TOMO 5',
  Icon: FlaskConical,
  title: 'Arte Experimental',
  desc: 'Técnica mixta, instalación, intervenciones, arte conceptual y propuestas contemporáneas.'
}, {
  n: 'TOMO 6',
  Icon: ClipboardCheck,
  title: 'Planificaciones y Evaluación',
  desc: 'Planificaciones anuales editables, rúbricas, consignas y evaluaciones listas para imprimir.'
}];
export function TomosGrid() {
  return <section className="py-20 lg:py-24 bg-white" data-id="element-221">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-223">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-50 text-brand-700 font-bold text-xs uppercase tracking-wider mb-5 border border-brand-100" data-id="element-224">
            6 Tomos completos
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-ink-900 mb-4 leading-tight tracking-tight" data-id="element-225">
            Lo que recibís <span className="text-brand-500" data-id="element-226">hoy mismo</span>
          </h2>
          <p className="text-lg text-ink-600" data-id="element-227">
            Una biblioteca completa de Arte para Secundaria, secuenciada y lista
            para aplicar.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-228">
          {tomos.map((tomo, i) => {
          const Icon = tomo.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="group relative bg-white rounded-3xl p-7 shadow-soft border border-ink-100 hover:shadow-card hover:-translate-y-1 hover:border-brand-200 transition-all overflow-hidden" data-id="element-229">
                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-24 h-24 bg-brand-50 rounded-bl-[3rem] -translate-y-2 translate-x-2 group-hover:bg-brand-100 transition-colors" data-id="element-230"></div>

                <div className="relative z-10" data-id="element-231">
                  <div className="text-xs font-black tracking-[0.2em] text-brand-500 mb-3" data-id="element-232">
                    {tomo.n}
                  </div>
                  <div className="w-14 h-14 rounded-2xl bg-ink-900 text-brand-500 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform" data-id="element-233">
                    <Icon className="w-7 h-7" data-id="element-234" />
                  </div>
                  <h3 className="font-extrabold text-xl text-ink-900 mb-3 leading-tight" data-id="element-235">
                    {tomo.title}
                  </h3>
                  <p className="text-ink-600 leading-relaxed text-sm" data-id="element-236">
                    {tomo.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}